import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { CircleMarker, Marker } from 'react-leaflet';
import { DivIcon, Point } from 'leaflet';
import MarkerIcon from '../../assets/img/controls/construction-marker.svg';


export const ConstructionPins = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [markers, setMarkers] = useState<any[]>([]);
    
    const getMarkers = () => {
        const dataMarkers= []
        for (let i = 0; i < 100; i++) {
            const name = searchParams.get('Location'+i+'Name');
            const lat = searchParams.get('Location'+i+'Lat');
            const lng = searchParams.get('Location'+i+'Lng');
            const radius = searchParams.get('Location'+i+'Radius');
            if(lat && lng) {
                let radiusValue = 0;
                if ( radius ){
                    radiusValue = parseInt(radius);
                }

                let data: any = {
                    lat: parseFloat(lat),
                    lng: parseFloat(lng),
                    name: name ?? ''
                }
                if (radiusValue > 0){
                    data.radius = radiusValue;
                }
                dataMarkers.push(data)
            }
        }
        return dataMarkers;
    }

    const icon = new DivIcon({
        iconSize:  new Point(21, 34),
        iconAnchor: new Point(10, 34),
        html: '<img src="' + MarkerIcon + '" width="20" height="35" />',
        className: 'construction-marker',
    });
 
    
    useEffect(() => {
        const data: any[] = getMarkers();
        setMarkers(data)
    }, []);

    
    return(
        <>
            {
                markers.map((pin, index) => {
                    const iconLabel = new DivIcon({
                        className: 'construction-label',
                        iconSize:  new Point(100, 20),
                        iconAnchor: new Point(50, 0),
                        html: '<div style="width: 100px; height: 20px; text-align: center; font-family: Arial; font-weight: bold; font-size: 14px; text-shadow: 0 0 10px #FFFFFF;">'+pin.name+'</div>',
                    });
                    
        
                    return (
                        <div key={'construction-pins-'+index}>
                            <Marker position={[pin.lat, pin.lng]} icon={icon}></Marker>
                            <Marker position={[pin.lat, pin.lng]} icon={iconLabel}></Marker>
                            {(pin.radius) > 0 && <CircleMarker center={[pin.lat, pin.lng]} fillOpacity={0.3} opacity={0.5} color={'#333333'} fillColor={'#666666'} radius={ pin.radius } ></CircleMarker>}
                        </div>
                    )
                    
                })
            }
        </>
    )
}
